import { Tab } from '../types';

interface TabBarProps {
  active: Tab;
  onChange: (tab: Tab) => void;
}

const TABS: { id: Tab; label: string; icon: string }[] = [
  { id: 'home', label: 'Home', icon: '🏠' },
  { id: 'packs', label: 'Packs', icon: '📦' },
  { id: 'marketplace', label: 'Market', icon: '🛒' },
  { id: 'giveaways', label: 'Giveaways', icon: '🎁' },
  { id: 'collection', label: 'Collection', icon: '🃏' },
];

export default function TabBar({ active, onChange }: TabBarProps) {
  return (
    <nav className="tab-bar flex bg-surface-card border-t border-white/5">
      {TABS.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`
              flex-1 flex flex-col items-center justify-center py-2 gap-0.5
              transition-colors duration-150 text-xs font-medium
              ${isActive
                ? 'text-accent-purple-light'
                : 'text-gray-500 hover:text-gray-300'
              }
            `}
          >
            <span className="text-xl leading-none">{tab.icon}</span>
            <span className={`leading-none mt-0.5 ${isActive ? 'opacity-100' : 'opacity-70'}`}>
              {tab.label}
            </span>
            {isActive && (
              <span className="absolute bottom-0 w-8 h-0.5 bg-accent-purple rounded-full" />
            )}
          </button>
        );
      })}
    </nav>
  );
}
